var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-setting-view" },
    [
      _vm._m(0),
      _c("el-divider"),
      _c(
        "el-form",
        { ref: "shareSettingForm", attrs: { model: _vm.shareSettingForm } },
        [
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label" }, [_vm._v("自定义分享图标")]),
              _c("el-switch", {
                model: {
                  value: _vm.shareSettingForm.shareWxImg,
                  callback: function ($$v) {
                    _vm.$set(_vm.shareSettingForm, "shareWxImg", $$v)
                  },
                  expression: "shareSettingForm.shareWxImg",
                },
              }),
            ],
            1
          ),
          _vm.shareSettingForm.shareWxImg
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "project-setting-label" }, [
                    _vm._v("请上传分享图片 * 建议尺寸500px*500px"),
                  ]),
                  _c(
                    "el-upload",
                    {
                      ref: "logoUpload",
                      attrs: {
                        action: _vm.getUploadUrl,
                        headers: _vm.getUploadHeader,
                        "on-success": _vm.uploadShareImgHandle,
                        "show-file-list": false,
                        accept:
                          ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "block" },
                        [
                          _c(
                            "el-image",
                            {
                              staticClass: "share-img",
                              attrs: {
                                src: _vm.shareSettingForm.shareWxImgUrl,
                                fit: "cover ",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "image-slot",
                                  attrs: { slot: "error" },
                                  slot: "error",
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-picture-outline",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label" }, [_vm._v("自定义分享标题")]),
              _c("el-switch", {
                model: {
                  value: _vm.shareSettingForm.shareWxTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.shareSettingForm, "shareWxTitle", $$v)
                  },
                  expression: "shareSettingForm.shareWxTitle",
                },
              }),
            ],
            1
          ),
          _vm.shareSettingForm.shareWxTitle
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    rules: [
                      {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur",
                      },
                    ],
                    prop: "shareWxTitleContent",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入标题" },
                    model: {
                      value: _vm.shareSettingForm.shareWxTitleContent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.shareSettingForm,
                          "shareWxTitleContent",
                          $$v
                        )
                      },
                      expression: "shareSettingForm.shareWxTitleContent",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label" }, [_vm._v("自定义分享描述")]),
              _c("el-switch", {
                model: {
                  value: _vm.shareSettingForm.shareWxDesc,
                  callback: function ($$v) {
                    _vm.$set(_vm.shareSettingForm, "shareWxDesc", $$v)
                  },
                  expression: "shareSettingForm.shareWxDesc",
                },
              }),
            ],
            1
          ),
          _vm.shareSettingForm.shareWxDesc
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    rules: [
                      {
                        required: true,
                        message: "请输入描述",
                        trigger: "blur",
                      },
                    ],
                    prop: "shareWxDescContent",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入描述" },
                    model: {
                      value: _vm.shareSettingForm.shareWxDescContent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.shareSettingForm,
                          "shareWxDescContent",
                          $$v
                        )
                      },
                      expression: "shareSettingForm.shareWxDescContent",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "submit-btn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveSettingHandle },
                },
                [_vm._v(" 保存设置 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.shareSettingForm.shareWxDesc ||
      _vm.shareSettingForm.shareWxTitle ||
      _vm.shareSettingForm.shareWxImg
        ? _c("div", [
            _c("div", { staticClass: "share-preview" }, [
              _c("div", { staticClass: "share-preview-msg" }, [
                _c("p", { staticClass: "share-preview-msg-title" }, [
                  _vm._v(
                    " " + _vm._s(_vm.shareSettingForm.shareWxTitleContent) + " "
                  ),
                ]),
                _c("div", { staticClass: "share-preview-body" }, [
                  _c("p", { staticClass: "share-preview-msg-desc" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.shareSettingForm.shareWxDescContent) +
                        " "
                    ),
                  ]),
                  _vm.shareSettingForm.shareWxImgUrl
                    ? _c("img", {
                        staticClass: "share-preview-img",
                        attrs: { src: _vm.shareSettingForm.shareWxImgUrl },
                      })
                    : _vm._e(),
                ]),
                _c("img", {
                  staticClass: "share-user-avatar",
                  attrs: { src: _vm.getUserInfos.avatar },
                }),
              ]),
              _c("div", { staticClass: "user-avatar-place" }),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "project-setting-title" }, [
      _vm._v(" 分享设置 "),
      _c("span", { staticClass: "small-font-size ml20 text-secondary-color" }, [
        _vm._v(" 自定义表单在微信分享的标题以及图片等 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }